import React from 'react';
import { useHistory } from 'react-router-dom';

import { Logo } from '../../Assets';
import { Button } from '../../Atoms';
import WelcomeImage from '../../Assets/images/welcome.png';

import './complete.scss';

const Complete = () => {
  const history = useHistory();

  const handleNext = () => {
    history.push('/');
  };

  return (
    <div className="complete-wrapper">
      <div className="logo-wrapper">
        <Logo width={173} height={34} />
      </div>
      <div className="custom-welcome-wrapper">
        <img src={WelcomeImage} alt="welcome-img" className="img-welcome" />
        <h3>Congratulations!</h3>
        <h5>You’re ready to get started on your learning journey.</h5>
        <p>
          You are now all setup inside Peak Mind. Let’s get started by taking your
          first survey.
        </p>
        <Button size="lg" color="red" onClick={handleNext}>
          Let's do this!
        </Button>
      </div>
    </div>
  );
};

export default Complete;
